import { type AccessTokenClaims, type PermissionContext } from '@aysar/contracts';

/**
 * Adapts the token's claims to the shape `hasPermission` takes.
 *
 * A translation and nothing more — N22 allows exactly ONE evaluator, and it is
 * `hasPermission` in `libs/contracts`, shared with `PermissionsGuard` on the api.
 * Nothing in the admin may re-implement wildcard or deny semantics, and nothing
 * may write `permissions.includes(...)`.
 *
 * `known` is left undefined on purpose. `hasPermission` then defaults it to
 * `catalogKeySet()`, which already includes P4's derived
 * `integrations.<capability>.manage` keys — so a hand-maintained list here could
 * only ever drift behind the catalogue and start denying real permissions.
 */
export function toPermissionContext(claims: AccessTokenClaims | null): PermissionContext | null {
  if (claims === null) return null;

  return {
    granted: claims.granted,
    denied: claims.denied,
    isSuperAdmin: claims.sa,
  };
}
